/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Repo,
    RepoFromJSON,
    RepoToJSON,
    UpgradeRequiredError,
    UpgradeRequiredErrorFromJSON,
    UpgradeRequiredErrorToJSON,
} from '../models';

export interface DisableRepoRequest {
    installationId: number;
    repoId: number;
}

export interface EnableRepoRequest {
    installationId: number;
    repoId: number;
}

export interface ListReposRequest {
    installationId: number;
}

/**
 * ReposApi - interface
 * 
 * @export
 * @interface ReposApiInterface
 */
export interface ReposApiInterface {
    /**
     * 
     * @param {number} installationId 
     * @param {number} repoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReposApiInterface
     */
    disableRepoRaw(requestParameters: DisableRepoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Repo>>;

    /**
     */
    disableRepo(requestParameters: DisableRepoRequest, initOverrides?: RequestInit): Promise<Repo>;

    /**
     * 
     * @param {number} installationId 
     * @param {number} repoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReposApiInterface
     */
    enableRepoRaw(requestParameters: EnableRepoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Repo>>;

    /**
     */
    enableRepo(requestParameters: EnableRepoRequest, initOverrides?: RequestInit): Promise<Repo>;

    /**
     * 
     * @param {number} installationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReposApiInterface
     */
    listReposRaw(requestParameters: ListReposRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Repo>>>;

    /**
     */
    listRepos(requestParameters: ListReposRequest, initOverrides?: RequestInit): Promise<Array<Repo>>;

}

/**
 * 
 */
export class ReposApi extends runtime.BaseAPI implements ReposApiInterface {

    /**
     */
    async disableRepoRaw(requestParameters: DisableRepoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Repo>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling disableRepo.');
        }

        if (requestParameters.repoId === null || requestParameters.repoId === undefined) {
            throw new runtime.RequiredError('repoId','Required parameter requestParameters.repoId was null or undefined when calling disableRepo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/repos/{repoId}/disable`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"repoId"}}`, encodeURIComponent(String(requestParameters.repoId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RepoFromJSON(jsonValue));
    }

    /**
     */
    async disableRepo(requestParameters: DisableRepoRequest, initOverrides?: RequestInit): Promise<Repo> {
        const response = await this.disableRepoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async enableRepoRaw(requestParameters: EnableRepoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Repo>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling enableRepo.');
        }

        if (requestParameters.repoId === null || requestParameters.repoId === undefined) {
            throw new runtime.RequiredError('repoId','Required parameter requestParameters.repoId was null or undefined when calling enableRepo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/repos/{repoId}/enable`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"repoId"}}`, encodeURIComponent(String(requestParameters.repoId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RepoFromJSON(jsonValue));
    }

    /**
     */
    async enableRepo(requestParameters: EnableRepoRequest, initOverrides?: RequestInit): Promise<Repo> {
        const response = await this.enableRepoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async listReposRaw(requestParameters: ListReposRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Repo>>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling listRepos.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/repos`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RepoFromJSON));
    }

    /**
     */
    async listRepos(requestParameters: ListReposRequest, initOverrides?: RequestInit): Promise<Array<Repo>> {
        const response = await this.listReposRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
